import { render, staticRenderFns } from "./BalanceHistoryTableMobile.vue?vue&type=template&id=3dcbeb9d&scoped=true"
import script from "./BalanceHistoryTableMobile.vue?vue&type=script&lang=js"
export * from "./BalanceHistoryTableMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcbeb9d",
  null
  
)

export default component.exports